import { useTranslation } from "react-i18next";

// iWarranty marketing / legal destinations. Kept as literals here because
// there is no centralised URL constant in the codebase yet and these are the
// platform vendor's own public pages (all verified live). If a shared config
// for these ever lands, swap these for it.
const IWARRANTY_WEBSITE_URL = "https://iwarranty.co";
const IWARRANTY_PRIVACY_URL = "https://iwarranty.co/privacy-policy";
const IWARRANTY_TERMS_URL = "https://iwarranty.co/platformserviceterms";

/**
 * Admin footer: iWarranty copyright line + a small set of iWarranty links.
 *
 * The iWarranty attribution is shown for every tenant, regardless of their
 * admin branding mode - the admin surface always carries the platform vendor's
 * copyright and legal/marketing links.
 */
export function AppFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto w-full border-t-[0.5px] border-[var(--rule)] bg-[var(--bg)]">
      <div className="page-container flex flex-col items-center justify-between gap-3 py-5 sm:flex-row">
        <p className="text-xs text-[var(--ink-3)]">
          {t("footer.copyright", {
            defaultValue: "© {{year}} iWarranty. All rights reserved.",
            year,
          })}
        </p>

        <nav className="flex items-center gap-5">
          <a
            href={IWARRANTY_WEBSITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-[var(--ink-3)] transition-colors hover:text-[var(--ink-1)]"
          >
            {t("footer.website", { defaultValue: "Website" })}
          </a>
          <a
            href={IWARRANTY_PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-[var(--ink-3)] transition-colors hover:text-[var(--ink-1)]"
          >
            {t("footer.privacy", { defaultValue: "Privacy Policy" })}
          </a>
          <a
            href={IWARRANTY_TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-[var(--ink-3)] transition-colors hover:text-[var(--ink-1)]"
          >
            {t("footer.terms", { defaultValue: "Terms" })}
          </a>
        </nav>
      </div>
    </footer>
  );
}
